<template>
    <div class="grid grid-cols-2 gap-4">
        <div class="w-full border border-a-brown-d7c7b8 rounded-10 p-2">
            <div class="flex">
                <div class="mr-auto ml-0 my-auto">
                    <div class="text-12 text-a-brown-9f8273">Select date</div>
                    <Datepicker class="w-full"
                        ref="selectDatepicker"
                        v-model="pickedDate"
                        :style="{'--vdp-selected-bg-color': '#d62300',
                                '--vdp-hover-bg-color': '#d62300'}"
                        :weekStartsOn="0"
                        :lowerLimit="lowerLimit"
                        :upperLimit="upperLimit"
                        :locale="localeDate"
                        :inputFormat="dateFormat"
                        :disabled="isDisabled"
                        @update:modelValue="onSelectDate()"
                    ></Datepicker>
                </div>
                <img @click="clickSelectDatepickerFocus()" class="mr-0 ml-auto my-auto" src="@/assets/icon/ic-arrow-down-brown.svg"/>
            </div>
        </div>
        <div class="w-full border border-a-brown-d7c7b8 rounded-10 p-2">
            <div class="flex">
                <div class="mr-auto ml-0 my-auto time-picker">
                    <div class="text-12 text-a-brown-9f8273">Select time</div>
                    <Datepicker class="w-full"
                            ref="selectTime"
                            v-model="pickedTime"
                            :style="{'--vdp-selected-bg-color': '#d62300',
                                '--vdp-hover-bg-color': '#d62300'}"
                            starting-view="time"
                            minimum-view="time"
                            inputFormat="HH:mm"
                            @update:modelValue="onSelectDate()"
                    ></Datepicker>
                </div>
                <img @click="clickSelectTimeFocus()" class="mr-0 ml-auto my-auto" src="@/assets/icon/ic-arrow-down-brown.svg"/>
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import DatetimeHelper from '@/helper/DatetimeHelper';
//lib
import Datepicker from 'vue3-datepicker' //https://icehaunter.github.io/vue3-datepicker/#example
import { th, enUS } from 'date-fns/locale'
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';

/**
 * @property {String} v-model:inputValue
 */
export default {
    name: 'InputCalendar',
    mixins: [LocaleMixin],
    components:{
        Datepicker,
    },
    props:{
        inputValue: { type: [String, Date, Number],  default: '' },
        lowerLimit: { type: Date, default: null },
        upperLimit: { type: Date, default: null },
        isDisabled: { type: Boolean, default: false },
        textLabel:  { type: String, default: null },

        dateFormat: { type: String, default: 'dd/MM/yyyy' },
    },
    data: function() {
        return {
            pickedDate: null,
            pickedTime: null,
            currentDate: new Date(),
            localeDate: null,
            startingView: 'time'
        };
    },
    created: function() {
        if (this.localeCode == 1033) {
            this.localeDate = enUS;
        } else {
            this.localeDate = th;
        }
        // this.pickedDate = this.inputValue
        this.initInput();
    },
    methods: {
        initInput: function() {
            if (Util.isEmptyStr(this.inputValue)) {
                // this.pickedDate = new Date();
                return;
            }

            let date = null;
            let time = null;
            let checkDate = this.inputValue.toString();

            if (this.inputValue instanceof Date) {
                
                date = this.inputValue;
                time = this.inputValue;
            } else if (checkDate.match(/^-{0,1}[0-9]+$/)) {
                date = DatetimeHelper.unixTimestampToDate(this.inputValue);
                time = DatetimeHelper.unixTimestampToDate(this.inputValue);
            } else {
                date = DatetimeHelper.stringToDate(this.inputValue, 'YYYY-MM-DD');
            }

            this.pickedDate = date;
            this.pickedTime = time;
        },
        clickSelectTimeFocus: function () {
            this.$refs.selectTime.inputRef.focus();
        },
        clickSelectDatepickerFocus: function () {
            this.$refs.selectDatepicker.inputRef.focus();
        },
        onSelectDate: function() {
            let inputDate = this.pickedDate;
            let inputTime = this.pickedTime;
            let inputDateTime = null;
            if (inputTime) { 
                inputDateTime = DatetimeHelper.mergeDateTimeToDate(inputDate,inputTime);
            } else {
                inputDateTime = inputDate;
            }
     
            let timestamp = DatetimeHelper.convertDateToTimeStampUnix(inputDateTime);
            let formated = DatetimeHelper.dateIsoFormat(inputDateTime);
            let value = {
                date: inputDateTime,
                timestamp: timestamp,
                formated: formated,
            };
            
            this.$emit('update:inputValue', inputDateTime);
            this.$emit('onDateChange', value);
        },
    },
}
</script>
<style lang="scss">
    .time-picker {
        .v3dp__popout {
            right: 0px;
        }
    }
</style>
